import { combineReducers, createAction, Reducer, UnknownAction } from '@reduxjs/toolkit';
import { contactsSlice } from './contacts/slice';
import { dashboardSlice } from './dashboard/slice';
import { workflowsSlice } from './workflows/slice';

const combinedReducer = combineReducers({
  [contactsSlice.name]: contactsSlice.reducer,
  dashboard: dashboardSlice.reducer,
  workflows: workflowsSlice.reducer,
});

export type RootState = ReturnType<typeof combinedReducer>;

/**
 * Resets every slice to its initial state. Dispatched when a session ends or a
 * new one begins (see `services/session.ts`) so no client state survives a user
 * switch.
 */
export const resetStoreState = createAction('app/resetState');

const rootReducer: Reducer<RootState, UnknownAction> = (state, action) => {
  if (action.type === resetStoreState.type) {
    return combinedReducer(undefined, action);
  }
  return combinedReducer(state, action);
};

export default rootReducer;
